var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"product-page"},[_c('product',{attrs:{"get-product":_vm.product}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }